import { render, staticRenderFns } from "./MoveContact.vue?vue&type=template&id=52d983e0&scoped=true&"
import script from "./MoveContact.vue?vue&type=script&lang=js&"
export * from "./MoveContact.vue?vue&type=script&lang=js&"
import style0 from "./MoveContact.vue?vue&type=style&index=0&id=52d983e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d983e0",
  null
  
)

export default component.exports